import {forwardRef} from "react";
import {useGetCurrentWorkspaceId} from "@tinct/core-workspace";
import {LayoutHeader} from "@tinct/web-layout";
import {UpdateComplianceForm} from "../../../forms/update-compliance-form";

type Step6ComplianceProps = {
  onSuccess?: () => void;
};

export const Step6Compliance = forwardRef<HTMLFormElement, Step6ComplianceProps>(({ onSuccess }, ref) => {
  const workspaceId = useGetCurrentWorkspaceId();

  return (
    <div className="container max-w-4xl mx-auto gap-8 flex flex-col py-8">
      <LayoutHeader
        pageTitle="Brand Guidelines"
        pageDescription="Compliance"
      />
      <UpdateComplianceForm ref={ref} organizationId={workspaceId} onSuccess={onSuccess} hideFooter />
    </div>
  );
});

Step6Compliance.displayName = 'Step6Compliance';
